"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageEstimateItemUnitType = void 0;
/**
 * Estimate Unit Types
 */
var UsageEstimateItemUnitType;
(function (UsageEstimateItemUnitType) {
    UsageEstimateItemUnitType["Hours"] = "Hours";
    UsageEstimateItemUnitType["Days"] = "Days";
    UsageEstimateItemUnitType["Count"] = "Count";
})(UsageEstimateItemUnitType || (exports.UsageEstimateItemUnitType = UsageEstimateItemUnitType = {}));
//# sourceMappingURL=usage-estimate-item-types.js.map